// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3tr4p","details":"details-UQsVh","item":"item-1gMJO","totalRefund":"totalRefund-3woHO"};